/** AUTO-GENERATED — do not edit. Source: edgen-app/android/config/app-identity.json */
export const ANDROID_PACKAGE_ID = "com.edwealth.ai";
export const ANDROID_PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.edwealth.ai";
